import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from "./locales/en.json";

// For the moment, we only support en version.
const lng = "en";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      en,
    },
    lng: lng,
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function(value, format, lng) {
         if (format === 'list') {
          if(value.length === 1) return value[0];
          return `${value.join(', ')}`;
        }
      },
    },
  });


export default i18n;